// extracted by mini-css-extract-plugin
module.exports = {"recommendation":"R1KVoX","recommendationWithAddToCard":"P_2PVx"};